import React, { Component } from 'react'
import { port } from '../../service/index'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

class ConferenceHeader extends Component {
    Download = async () => {
        console.log('Download')
        try {
            const { conference_id } = this.props
            const { token } = this.props.login.user
            window.open(port + '/zip/' + conference_id, '_blank')

        } catch (err) {
            console.log(err)
        }
    }

    Print = async () => {
        console.log('Print')
        try {
            const { conference_id } = this.props
            const { token } = this.props.login.user
            window.open(port + '/print_qrcode/' + conference_id, '_blank')

        } catch (err) {
            console.log(err)
        }
    }

    render() {
        const { title, detail, count_person } = this.props
        return (
            <div className='conference-header' >
                <div style={{ width: '80%' }} >
                    <p style={{ color: '#fff', fontSize: 44, marginBottom: 20, textAlign: 'center' }} >{title}</p>
                    <span style={{ display: 'flex', flexDirection: 'row' }} >
                        <p style={{ fontSize: 32, color: '#73D5D8', marginRight: 12, fontFamily: 'th_k2d_july8regular' }} > ชื่อการประชุม </p>
                        <p style={{ fontSize: 32, color: '#fff' }} >{title}</p>
                    </span>
                    {/* edit */}
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} >
                        <p style={{ fontSize: 32, color: '#73D5D8', marginRight: 20, marginBottom: 10 }} > รายละเอียดการประชุม </p>
                        {this.props.user_create_id === this.props.login.user.user_id ? <button
                            className={"conference-btn selected"}
                            onClick={this._onEdit}
                        >
                            แก้ไขการประชุม
                        </button> : null}
                    </div>

                    <ConferenceDetail detail={detail} />
                    <ConferenceSubDetail1 {...this.props} pdf_count={this.props.pdf.number} onDownload={this.Download} onPrint={this.Print} treeNum={this.props.tree} showQR={this.props.login.user.role ? this.props.login.user.role.toLowerCase().includes('admin') : false} />
                </div>
            </div>
        )
    }

    _onEdit = () => {
        const { conference_id, title, detail, } = this.props
        this.props.history.push({ pathname: '/editConference/' + conference_id, state: { title, detail } })
    }
}

const ConferenceDetail = ({ detail }) =>
    <div>
        <textarea
            className='text-detail'
            value={detail}
            disabled={true}
            rows={8}
        />
    </div>


const ConferenceSubDetail1 = ({ mode, count_person, pdf_count, onDownload, onPrint, showQR = false, treeNum }) => {
    return (<div className='conference-sub1' >
        <ShowDetail src={require('../../assets/icon/user_select.png')}
            title='จำนวนผู้เข้าร่วมประชุม'
            subtitle='มีบุคลากรทั้งหมด'
            unit='คน'
            num={count_person}

        />
        {showQR ?
            <ShowDetail src={require('../../assets/icon/qrcode.png')}
                title='พิมพ์คิวอาร์โค้ด'
                subtitle='พิมพ์คิวอาร์โค้ดเพื่อ เข้า/ออกประชุม'
                marginLeft={10}

                onClick={onPrint}
            /> : null
        }

        <ShowDetail src={require('../../assets/icon/download.png')}
            title='ดาวน์โหลดเอกสารทั้งหมด'
            subtitle='ไฟล์เอกสารทั้งหมด'
            unit='ไฟล์'
            num={pdf_count}
            marginLeft={10}
            onClick={onDownload}
        />
        <ShowDetail src={require('../../assets/icon/tree.png')}
            title='ประหยัดการใช้ต้นไม้'
            subtitle='ประหยัดได้ถึง'
            num={treeNum}
            marginLeft={10}
            unit='ต้น'
        />
    </div>)
}

const ShowDetail = ({ src, title, subtitle, num, unit, marginLeft, marginRight, onClick }) => {
    return (<div className='show-detail' style={{ marginLeft, marginRight }} >
        <img src={src} className='detail-image' onClick={onClick} />
        <span style={{ width: '100%' }} >
            <p style={{ color: '#73D5D8', fontSize: 14 }} >{title}</p>
            <span style={{ display: 'flex', flexDirection: 'row' }} >
                <p style={{ color: '#fff', fontSize: 14 }}  >{subtitle}</p>
                <span style={{ display: 'flex', flex: 1, justifyContent: 'flex-end', marginRight: 20 }} >
                    <br />
                    <span style={{ display: 'flex', flexDirection: 'row' }} >
                        <p style={{ color: '#73D5D8', fontSize: 14 }} > {num}&nbsp;  </p>
                        <p style={{ color: '#fff', fontSize: 14 }}> {unit} </p></span>
                </span>
            </span>
        </span>
    </div>)
}

const mapStateToProps = (state) => ({
    pdf: state.pdf,
    login: state.login,
})


export default withRouter(connect(mapStateToProps)(ConferenceHeader))


// WEBPACK FOOTER //
// ./src/pages/Conference/ConferenceHeader.js